import * as yup from 'yup';
import moment from 'moment';

export const validations = yup.object().shape({
  startDate: yup
    .string()
    .test(function(date) {
      if(!moment(date, 'YYYY-MM-DD').isValid()) {
        return this.createError({
          message: 'A data inicial é obrigatória',
          path: 'startDate'
        });
      }

      return true;
    }),
  endDate: yup
    .string()
    .test(function(date) {
      if(!moment(date, 'YYYY-MM-DD').isValid()) {
        return this.createError({
          message: 'A data final é obrigatória',
          path: 'endDate'
        });
      }

      return true;
    }),
  situation: yup.string().required('A situação é obrigatória')
});

export const modalValidations = yup.object().shape({
  reason: yup
    .string()
    .required('O motivo é obrigatório'),
  password: yup
    .string()
    .required('A senha é obrigatória'),
  passwordConfirm: yup
    .string()
    .when('password', (password, schema) =>
      password ? schema.required('Confirme a senha') : schema
    )
    .oneOf(
      [yup.ref('password'), null],
      'A senha e a confirmação devem ser iguais'
    ),
  actionConsent: yup
    .boolean()
    .test(function(actionConsent) {
      if(!actionConsent) {
        return this.createError({
          message: 'Você precisa confirmar este campo',
          path: 'actionConsent'
        });
      }

      return true;
    })
});